import { useState, useEffect } from 'react';
import axios from 'axios';

const MOODS = ['😊 Bine', '😐 Ok', '😟 Tensionat', '😰 Anxios', '😵 Copleșit'];
const TRIGGERS = ['Muncă', 'Relații', 'Sănătate', 'Finanțe', 'Social', 'Somn', 'Altele'];

export default function Journal() {
  const [entries, setEntries] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ mood: '', intensity: 5, note: '', triggers: [] });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = () => {
    axios.get('/api/mood').then(({ data }) => setEntries(data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const toggleTrigger = t => setForm(f => ({
    ...f, triggers: f.triggers.includes(t) ? f.triggers.filter(x => x !== t) : [...f.triggers, t]
  }));

  const save = async () => {
    if (!form.mood) return alert('Selectează starea ta.');
    setSaving(true);
    try {
      await axios.post('/api/mood', { mood: form.mood, intensity: form.intensity, note: form.note, triggers: form.triggers.join(', ') });
      setForm({ mood: '', intensity: 5, note: '', triggers: [] });
      setShowForm(false);
      load();
    } catch { alert('Eroare la salvare. Încearcă din nou.'); }
    finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!window.confirm('Ștergi această intrare?')) return;
    await axios.delete(`/api/mood/${id}`);
    setEntries(e => e.filter(x => x.id !== id));
  };

  const fmt = d => new Date(d).toLocaleDateString('ro-RO', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 20, fontWeight: 700 }}>Jurnalul meu</div>
        <button className="btn btn-primary" style={{ padding: '8px 16px', fontSize: 13 }} onClick={() => setShowForm(s => !s)}>
          {showForm ? '✕ Anulează' : '+ Notă nouă'}
        </button>
      </div>

      {/* New entry form */}
      {showForm && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="form-group">
            <label className="input-label">CUM TE SIMȚI?</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {MOODS.map(m => (
                <button key={m} onClick={() => setForm(f => ({ ...f, mood: m }))} style={{
                  padding: '6px 12px', borderRadius: 20, fontSize: 13, cursor: 'pointer',
                  border: `1.5px solid ${form.mood === m ? 'var(--teal)' : 'var(--border)'}`,
                  background: form.mood === m ? '#E0F5F7' : 'none',
                  color: form.mood === m ? 'var(--teal)' : 'var(--dark)',
                }}>
                  {m}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="input-label">INTENSITATE ANXIETATE: {form.intensity}/10</label>
            <input type="range" min={1} max={10} step={1} value={form.intensity} onChange={e => setForm(f => ({ ...f, intensity: +e.target.value }))} />
          </div>

          <div className="form-group">
            <label className="input-label">FACTORI DECLANȘATORI</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {TRIGGERS.map(t => (
                <button key={t} onClick={() => toggleTrigger(t)} style={{
                  padding: '5px 12px', borderRadius: 16, fontSize: 12, cursor: 'pointer',
                  border: `1.5px solid ${form.triggers.includes(t) ? 'var(--teal)' : 'var(--border)'}`,
                  background: form.triggers.includes(t) ? '#E0F5F7' : 'none',
                  color: form.triggers.includes(t) ? 'var(--teal)' : 'var(--muted)',
                }}>
                  {t}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="input-label">NOTE (opțional)</label>
            <textarea className="input" style={{ minHeight: 80, resize: 'vertical' }} placeholder="Ce s-a întâmplat? Cum te simți acum?"
              value={form.note} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} />
          </div>

          <button className="btn btn-primary btn-full" onClick={save} disabled={saving}>
            {saving ? 'Se salvează...' : 'Salvează nota'}
          </button>
        </div>
      )}

      {/* Entries list */}
      {loading && <div style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center', marginTop: 20 }}>Se încarcă...</div>}
      {!loading && entries.length === 0 && !showForm && (
        <div style={{ textAlign: 'center', color: 'var(--muted)', marginTop: 40 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📓</div>
          <div>Nicio notă încă. Adaugă prima ta înregistrare.</div>
        </div>
      )}
      {entries.map(e => (
        <div key={e.id} className="card" style={{ marginBottom: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 3 }}>{fmt(e.created_at)}</div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{e.mood} · Intensitate {e.intensity}/10</div>
              {e.triggers && <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>🏷 {e.triggers}</div>}
              {e.note && <div style={{ fontSize: 13, marginTop: 6, color: 'var(--dark)', lineHeight: 1.5 }}>{e.note}</div>}
            </div>
            <button onClick={() => del(e.id)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 16, padding: '0 4px' }}>✕</button>
          </div>
        </div>
      ))}
    </div>
  );
}
